<template>
<div class="web-poll">
	<h2 v-if="count"><i class="fas fa-poll"></i> {{tr('Poll')}}</h2>
	<form class="border rounded px-3 pb-3" v-if="poll.show" v-for="(poll,p) in polls" @submit.prevent="send(p)">
		<div class="mt-3" v-for="(item,i) in poll.data">
			<div class="text-primary mb-2">{{item.q}}</div>
			<label class="ml-4" :class="{'w-100': answer.length > 40}" v-for="(answer,j) in item.a"><input class="mr-2" :type="item.m ? 'checkbox' : 'radio'" :name="poll.name + i" v-model="item.r" :value="answer" :required="item.n && !item.r.length">{{answer}}</label>
			<div class="" v-if="item.a.length == 0"><input class="form-control" v-model="item.r"></div>
		</div>
		<button class="btn btn-outline-success d-block ml-auto mt-3" type="submit"><i class="fas fa-paper-plane"></i> {{tr('Send')}}</button>
	</form>
</div>
</template>

<script>
import * as firebase from 'firebase/app';
import 'firebase/database';

export default {
	name: 'WebPoll',
	inject: [
		'lng',
		'tr',
	],
	props: {
		event: String,
		user: String,
	},
	data: function () {
		return {
			polls: [],
		};
	},
	created: function () {
		this.init();
	},
	computed: {
		count: function () {
			var c = 0;
			for(var i = 0; i < this.polls.length; i++) {
				if(this.polls[i].show) {
					c++;
				}
			}
			return c;
		},
	},
	methods: {
		init: function () {
			firebase.database().ref(this.event + '/polls').on("child_added", this.getPoll);
		},
		getPoll: function (data) {
// 			console.log(data);
			var lang = this.lng();
			var val = data.val();
			if(!val.hasOwnProperty(lang)) return;
			val = val[lang].split("\n\n");
			for(var i = 0; i < val.length; i++) {
				var a = val[i].split("\n");
				var q = a.shift();
				val[i] = {
					q: q.replace(/^[\*\+]/, ''), // question
					a: a, // answers
					r: [], // reply
					n: q.search(/^[\*\+]/) != -1, // needed
					m: q.search(/^[\+]/) != -1, // multiple choice
				};
			}
// 			console.log(data.key);
// 			console.log(val);
			var i = this.polls.push({ name: data.key, data: val, show: true }) - 1;
			firebase.database().ref(this.event + '/polls/' + data.key + '/r/' + this.user)
				.once('value')
				.then((data) => {
					if(data.val()) {
// 						this.polls.splice(i, 1);
						this.polls[i].show = false;
					}
				});
		},
		send: function (p) {
			var res = [];
			for(var i = 0; i < this.polls[p].data.length; i++) {
				res.push([this.polls[p].data[i].q, this.polls[p].data[i].r]);
			}
			firebase.database().ref(this.event + '/polls/' + this.polls[p].name + '/r/' + this.user).set(res);
// 			this.polls.splice(p, 1);
			this.polls[p].show = false;
		},
	},
}
</script>

<style>
</style>
